import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import Heading from 'components/v2/Heading'
import { Button } from 'components/v2/Button'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import Modal from 'components/v2/Modal'
import { useMutation } from '@apollo/client'
import { CANCEL_BUSINESS_CLIENT_KREDIT_DEPOSIT } from 'features/BusinessClients/mutations'
import { useParams } from 'react-router-dom'

const CancelCreditsModalContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

interface ICancelCreditsDepositModalProps {
  transactionId: string
  onClose: () => void
}

export const CancelCreditsDepositModal = ({
  transactionId,
  onClose
}: ICancelCreditsDepositModalProps): ReactElement => {
  const { businessClientId } = useParams()
  const [cancelCreditDeposit, { loading, error }] = useMutation(CANCEL_BUSINESS_CLIENT_KREDIT_DEPOSIT, {
    onError: () => undefined
  })

  const onCancelCreditDeposit = async (): Promise<void> => {
    cancelCreditDeposit({
      variables: {
        input: {
          id: businessClientId,
          transactionID: transactionId
        }
      }
    })
  }

  return (
    <Modal.Container onClose={onClose}>
      <CancelCreditsModalContent>
        <Heading.H5>
          <FormattedMessage id="cancelCreditDepositModal.title" defaultMessage="Are you sure to delete this top up?" />
        </Heading.H5>
        {error && (
          <ErrorMessage>
            <FormattedMessage
              id="cancelCreditDepositModal.error"
              defaultMessage="There was an error while cancelling the deposit"
            />
          </ErrorMessage>
        )}
        <Modal.Actions>
          <Button kind="cancel" onClick={onClose}>
            <FormattedMessage id="dictionary.cancel" defaultMessage="Cancel" />
          </Button>
          <Button type="submit" kind="primary" loading={loading} onClick={onCancelCreditDeposit}>
            <FormattedMessage id="dictionary.accept" defaultMessage="Accept" />
          </Button>
        </Modal.Actions>
      </CancelCreditsModalContent>
    </Modal.Container>
  )
}
